<div class="donut-droppable" ref="view"><slot></slot></div>